import createApiServices from "./createApiServices";
import { extendUrl3D } from "../../views/helpers/extenent-url";

const prefixURL = `${extendUrl3D.url}/api/order` || 'https://tool3d-staging-mcvn.merchize.com/api/order'

const api = createApiServices({ baseUrl: prefixURL})

export const getListPartner = (data) => {
    return api.makeAuthRequest({
        url: `/partners`,
        method: 'GET',
        params: data,
    })
}

export const getItemProgress = async (batchItem) => {
    return api.makeAuthRequest({
        url: `/orders/item-progress/${batchItem}`,
        method: 'GET'
    })
}